module.exports = __webpack_public_path__ + "static/media/cc_cookies.8c69e949.JPG";